export interface ParameterPenilaianModel {
  id: number
  ulid: string
  name: string
  description: string
  criteria_id: number
  created_at: string
  updated_at: string
  upaya_pengelolaan_risikos: UpayaPengelolaanRisiko[]
  hasil_evaluasis: HasilEvaluasi[]
  kriteria_penilaians: KriteriaPenilaian[]
  criteria: Criteria
}

export interface UpayaPengelolaanRisiko {
  id: number
  ulid: string
  parameter: string
  nilai: string
  id_parameter_penilaian: number
  created_at: string
  updated_at: string
}

export interface HasilEvaluasi {
  id: number
  ulid: string
  x_name: string
  y_name: string
  x_value: string[]
  y_value: string[]
  x: string[]
  y: string[]
  is_x_range: boolean
  is_y_range: boolean
  kuadran: string
  kesimpulan: string
  id_parameter_penilaian: number
  created_at: string
  updated_at: string
}

export interface KriteriaPenilaian {
  id: number
  ulid: string
  code: string
  name: string
  value: number
  is_active: boolean
  id_parameter_penilaian: number
  created_at: string
  updated_at: string
}

export interface Criteria {
  ulid: string
  code: string
  name: string
  description: string
  matrix: Matrix[][]
  matrix_level: MatrixLevel
  status: string
  properties: any
}

export interface Matrix {
  x: number
  y: number
  color: string
  label: string
  tolerance: boolean
}

export interface MatrixLevel {
  x: string[]
  y: string[]
  label: any
  level: any
  criteria: any
}

export interface ParameterPenilaianDataModel {
  main: {
    data: ParameterPenilaianModel[];
    total: number;
  };
}

export enum ParameterPenilaianActionType {
  GetParameterPenilaian = "⌘➝Parameter Setting➝Scoring➝ParameterPenilaian",
}

export type ParameterPenilaianAction = {
  type: ParameterPenilaianActionType.GetParameterPenilaian;
  data: {
    data: ParameterPenilaianModel[];
    total: number;
  };
};
